import { fetchPlans } from './effects';
import { $plans } from './states';

// Fetch plans
$plans.on(fetchPlans.doneData, (_, data) => data);
